import { render, staticRenderFns } from "./phase-assignment-infraction-popover.vue?vue&type=template&id=52833e89&"
import script from "./phase-assignment-infraction-popover.vue?vue&type=script&lang=ts&"
export * from "./phase-assignment-infraction-popover.vue?vue&type=script&lang=ts&"
import style0 from "./phase-assignment-infraction-popover.vue?vue&type=style&index=0&id=52833e89&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports